import React from 'react';
import about_img from '../images/about-img.svg';
// import about_1_img from '../images / about - extra - 1.svg';
// import about_2_img from '../images/about-extra-2.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTools, faStream, faDatabase, faRocket } from '@fortawesome/free-solid-svg-icons';

const About = () => {
    return (
        <section id="about">
            {/* Hero Section */}
            <section className="about-hero text-center pt-5">
                <div className="container" data-aos="fade-up">
                    <h2 className="display-5 fw-bold section-title mb-3">About Us</h2>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: "800px" }}>
                        We are a forward-thinking software development company empowering businesses worldwide with
                        innovative, scalable, and high-performance digital solutions. From startups to enterprises, we help
                        brands transform through technology and creativity.
                    </p>
                </div>
            </section>

            {/* Who We Are */}
            <section className="about-who py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right">
                            <img src={about_img} className="img-fluid rounded-4 shadow-sm" alt="About Anmatics" />
                        </div>
                        <div className="col-lg-6" data-aos="fade-left">
                            <h3 className="fw-bold mb-3">Who We Are</h3>
                            <p>
                                Anmatics Technologies is a team of passionate engineers, designers, and innovators united by a shared
                                mission to create digital experiences that deliver measurable impact. We specialize in building
                                enterprise-grade web and mobile applications, custom SaaS platforms, and end-to-end technology solutions.
                            </p>
                            <p>
                                Our expertise extends across diverse domains including manufacturing and industrial automation
                                enabling us to deliver world-class software that drives efficiency, innovation, and business growth.
                            </p>
                            <p>
                                When your offshore team overpromised and deadlines collapsed, we step in.
                                Our senior Angular, NodeJS, and .NET developers clean up messy codebases, stabilize releases, and help you finally deliver without starting from scratch.
                            </p>
                            {/* What We Do */}
                            <div className="mt-4">
                                <h4 className="fw-bold mb-3">What We Do</h4>
                                <h5 className="fw-semibold mb-3">Full-Stack Rescue &amp; Stabilization</h5>
                                <ul className="list-unstyled m-0">
                                    <li className="d-flex align-items-start mb-2">
                                        <span className="me-2 mt-1 text-primary"><FontAwesomeIcon className="me-2 contact-icon" icon={faSearch} /></span>
                                        <span>Deep audit of existing Angular, NodeJS, or .NET codebases</span>
                                    </li>
                                    <li className="d-flex align-items-start mb-2">
                                        <span className="me-2 mt-1 text-primary"><FontAwesomeIcon className="me-2 contact-icon" icon={faTools} /></span>
                                        <span>Refactor critical modules and clean architecture debt</span>
                                    </li>
                                    <li className="d-flex align-items-start mb-2">
                                        <span className="me-2 mt-1 text-primary"><FontAwesomeIcon className="me-2 contact-icon" icon={faStream} /></span>
                                        <span>Rebuild deployment pipelines (CI/CD, versioning, rollback safety)</span>
                                    </li>
                                    <li className="d-flex align-items-start mb-2">
                                        <span className="me-2 mt-1 text-primary"><FontAwesomeIcon className="me-2 contact-icon" icon={faDatabase} /></span>
                                        <span>Optimize APIs and database structure (MSSQL / MySQL)</span>
                                    </li>
                                    <li className="d-flex align-items-start">
                                        <span className="me-2 mt-1 text-primary"><FontAwesomeIcon className="me-2 contact-icon" icon={faRocket} /></span>
                                        <span>Prepare the project for feature growth or investor demo</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Approach */}
            <section className="approach-section py-5">
                <div className="container text-center" data-aos="fade-up">
                    <h3 className="fw-bold mb-4 section-title">Our Approach</h3>
                    <p className="text-muted mb-5 section-subtitle">
                        We combine strategy, creativity, and technology to build future-ready digital ecosystems that help
                        businesses thrive in a connected world.
                    </p>
                    <div className="row g-4">
                        <div className="col-md-3">
                            <div className="approach-card p-4 rounded-3 shadow-sm bg-white h-100">
                                <h5 className="approach-heading mb-2">1. Discover</h5>
                                <p className="text-muted small mb-0">Understanding your business goals and vision in depth.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="approach-card p-4 rounded-3 shadow-sm bg-white h-100">
                                <h5 className="approach-heading mb-2">2. Design</h5>
                                <p className="text-muted small mb-0">Creating user-focused, visually engaging, and scalable solutions.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="approach-card p-4 rounded-3 shadow-sm bg-white h-100">
                                <h5 className="approach-heading mb-2">3. Develop</h5>
                                <p className="text-muted small mb-0">Building high-performance, secure, and reliable applications.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="approach-card p-4 rounded-3 shadow-sm bg-white h-100">
                                <h5 className="approach-heading mb-2">4. Deliver</h5>
                                <p className="text-muted small mb-0">Ensuring quality, efficiency, and on-time project completion.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-us py-5">
                <div className="container" data-aos="fade-up">
                    <div className="text-center mb-5">
                        <h3 className="fw-bold mb-3">Why Choose Anmatics Technologies?</h3>
                        <p className="text-muted">Your trusted technology partner for innovation and growth.</p>
                    </div>
                    <div className="row g-4">
                        <div className="col-md-3">
                            <div className="p-4 bg-white shadow-sm rounded-3 h-100 border-start border-4 border-primary">
                                <h6 className="fw-bold">Expert Team</h6>
                                <p className="small text-muted mb-0">Skilled professionals with proven expertise in software development.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="p-4 bg-white shadow-sm rounded-3 h-100 border-start border-4 border-info">
                                <h6 className="fw-bold">Innovative Solutions</h6>
                                <p className="small text-muted mb-0">We leverage modern technologies to craft future-ready solutions.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="p-4 bg-white shadow-sm rounded-3 h-100 border-start border-4 border-success">
                                <h6 className="fw-bold">Client-Centric</h6>
                                <p className="small text-muted mb-0">Your vision drives our process, we build around your business goals.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="p-4 bg-white shadow-sm rounded-3 h-100 border-start border-4 border-warning">
                                <h6 className="fw-bold">Global Reach</h6>
                                <p className="small text-muted mb-0">Trusted by businesses across India and around the globe.</p>
                            </div>
                        </div>
                        {/* New Cards from Image */}
                        <div className="col-md-3">
                            <div className="p-4 bg-white shadow-sm rounded-3 h-100 border-start border-4 border-secondary">
                                <h6 className="fw-bold">Structured Audit & Modular Refactor</h6>
                                <p className="small text-muted mb-0">We clean up messy codebases with zero rewrite dogma.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="p-4 bg-white shadow-sm rounded-3 h-100 border-start border-4 border-danger">
                                <h6 className="fw-bold">Stable Build Pipeline</h6>
                                <p className="small text-muted mb-0">Measurable progress in 2 weeks, not endless delays.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="about-cta text-center py-5" data-aos="fade-up">
                <div className="container position-relative">
                    <div className="cta-bg-gradient"></div>
                    <h3 className="fw-bold mb-3 text-white">Let’s Build the Future, Together</h3>
                    <p className="lead mb-4 text-white">
                        Whether you’re launching a startup or transforming an enterprise,
                        <span className="fw-semibold text-white"> Anmatics Technologies </span>
                        is your trusted partner for success.
                    </p>
                    <a href="#contact" className="btn btn-gradient btn-lg rounded-pill shadow-lg text-white">
                        Get in Touch
                    </a>
                </div>
            </section>
        </section>
    );
};

export default About;
